import { type IPagingApi, type ISortApi, type ISortInformation } from "@comet/admin";
import { useMemo } from "react";

interface UseMemoizedTableVariablesProps<TVariables, TPagingType> {
    pagingApi: IPagingApi<TPagingType>;
    sortApi: ISortApi;
    addAdditionalQueryVariablesFn?: () => TVariables;
}

interface DefaultReturnValue {
    page: number;
    sort: ISortInformation;
}

export const useMemoizedTableVariables = <TVariables = DefaultReturnValue, TPagingType = number>({
    pagingApi,
    sortApi,
    addAdditionalQueryVariablesFn = () => ({}) as TVariables,
}: UseMemoizedTableVariablesProps<TVariables, TPagingType>): TVariables => {
    const { current: page } = pagingApi;
    const { current: sort } = sortApi;

    return useMemo(() => {
        const variables = addAdditionalQueryVariablesFn();

        return { page, sort, ...variables };
    }, [page, sort, addAdditionalQueryVariablesFn]);
};
